<main>
	<div class="container pt-5">

        <div class="card m-auto box" style="width: 30vw;">
            <div class="card-body text-center">

                <p class="card-text mt-5">
                    <span style="font-size: 40px; color: #95bf0b;"><i class="far fa-check-circle"></i></span>
                </p>  

                <h2 class="card-title">Solicitação de Contratação Realizada com Sucesso</h2>

                <p class="card-text mt-5 mb-5">
                    Acompanhe seu processo de Seguro no Autoatendimento do Viva Mais Previdência, <a routerLink="/logado/seguro/acompanhar-solicitacoes">Clique aqui</a>
                </p>
                
            </div>
          </div>


    </div>
</main>        